/**
 * ROLVEA Cart Drawer v3 — behaviour.
 * - Cosmetic scarcity and delivery calculation.
 * - Horizontal upsell hint handling.
 * - Automatic application of the configured manual discount code when the
 *   server-rendered offer block reports that its quantity condition is met.
 * - Re-initialisation after Shopify/theme AJAX cart renders.
 */
(function () {
  'use strict';
  if (window.RolveaCartV2) return;

  var DRAWER_ID = 'CartDrawer';
  var DONE = 'data-rv2-done';
  var applyingDiscounts = Object.create(null);
  var reduceMotion = false;
  try { reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e) {}

  var FALLBACK_DAYS = ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'];
  var FALLBACK_MONTHS = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'];

  function toInt(v, fallback) { var n = parseInt(v, 10); return isNaN(n) ? fallback : n; }
  function attr(el, name) { var v = el.getAttribute(name); return v == null ? '' : v; }
  function splitLabels(str, fallback) {
    if (!str) return fallback;
    var arr = str.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    return arr.length ? arr : fallback;
  }
  function esc(s) {
    return String(s).replace(/[&<>\"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '\"': '&quot;' }[c]; });
  }
  function ssGet(key) {
    try { var v = window.sessionStorage.getItem(key); return v == null ? null : parseInt(v, 10); } catch (e) { return null; }
  }
  function ssSet(key, val) { try { window.sessionStorage.setItem(key, String(val)); } catch (e) {} }
  function ssRemove(key) { try { window.sessionStorage.removeItem(key); } catch (e) {} }

  function fillScarcity(scope) {
    var nodes = scope.querySelectorAll('[data-rv2-scarcity]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.hasAttribute(DONE)) continue;
      var min = toInt(attr(el, 'data-min'), 2);
      var max = toInt(attr(el, 'data-max'), 6);
      if (max < min) { var tmp = min; min = max; max = tmp; }
      var variantId = attr(el, 'data-variant-id') || attr(el, 'data-rv2-scarcity');
      var variantTitle = attr(el, 'data-variant-title');
      var key = 'rolvea_scarcity_' + (variantId || variantTitle || 'x');
      var n = ssGet(key);
      if (n === null || isNaN(n)) { n = min + Math.floor(Math.random() * (max - min + 1)); ssSet(key, n); }
      var prefix = attr(el, 'data-variant-prefix') || ' in ';
      var variantSuffix = (variantTitle && variantTitle !== 'Default Title') ? (prefix + variantTitle) : '';
      var template = attr(el, 'data-template') || el.textContent || 'Solo [n] rimasti[variant]';
      el.textContent = template.replace(/\[n\]/g, String(n)).replace(/\[variant\]/g, variantSuffix);
      el.setAttribute(DONE, '1');
    }
  }

  function addDays(base, n, skipWeekends) {
    var d = new Date(base.getTime());
    if (!skipWeekends) { d.setDate(d.getDate() + n); return d; }
    var added = 0;
    while (added < n) { d.setDate(d.getDate() + 1); var dow = d.getDay(); if (dow !== 0 && dow !== 6) added++; }
    return d;
  }
  function fmtDate(date, dayLabels, monthLabels, withMonth) {
    var s = dayLabels[date.getDay()] + ' ' + date.getDate();
    if (withMonth) s += ' ' + monthLabels[date.getMonth()];
    return s;
  }
  function fillDelivery(scope) {
    var nodes = scope.querySelectorAll('[data-rv2-delivery]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.hasAttribute(DONE)) continue;
      var minDays = toInt(attr(el, 'data-min-days'), 3);
      var maxDays = toInt(attr(el, 'data-max-days'), 6);
      if (maxDays < minDays) { var t = minDays; minDays = maxDays; maxDays = t; }
      var excludeWeekends = !/^(false|0|no|off)$/i.test(attr(el, 'data-exclude-weekends'));
      var cutoff = attr(el, 'data-cutoff') || '23:59';
      var template = attr(el, 'data-template') || el.textContent || 'Order by [cutoff] → estimated delivery [start_date] – [end_date]';
      var dayLabels = splitLabels(attr(el, 'data-day-labels'), FALLBACK_DAYS);
      var monthLabels = splitLabels(attr(el, 'data-month-labels'), FALLBACK_MONTHS);
      var today = new Date(); today.setHours(0, 0, 0, 0);
      var start = addDays(today, minDays, excludeWeekends);
      var end = addDays(today, maxDays, excludeWeekends);
      if (end < start) end = start;
      var sameMonth = start.getFullYear() === end.getFullYear() && start.getMonth() === end.getMonth();
      var startStr = fmtDate(start, dayLabels, monthLabels, !sameMonth);
      var endStr = fmtDate(end, dayLabels, monthLabels, true);
      el.innerHTML = template
        .replace(/\[cutoff\]/g, '<strong class="rv2-delivery__cutoff">' + esc(cutoff) + '</strong>')
        .replace(/\[start_date\]/g, '<strong class="rv2-delivery__date">' + esc(startStr) + '</strong>')
        .replace(/\[end_date\]/g, '<strong class="rv2-delivery__date">' + esc(endStr) + '</strong>');
      el.setAttribute(DONE, '1');
    }
  }

  function wireOne(container, hint) {
    if (!container || container.hasAttribute(DONE)) return;
    container.setAttribute(DONE, '1');
    if (!hint) return;
    var onScroll = function () {
      if (container.scrollLeft > 8) { hint.classList.add('rv2-carousel-hint--hidden'); container.removeEventListener('scroll', onScroll); }
    };
    container.addEventListener('scroll', onScroll, { passive: true });
  }
  function wireCarousel(scope) {
    var tracks = scope.querySelectorAll('[data-rv2-upsell-track]');
    for (var i = 0; i < tracks.length; i++) {
      var root = tracks[i].closest ? tracks[i].closest('.rv2-upsell') : tracks[i].parentNode;
      wireOne(tracks[i], root && root.querySelector ? root.querySelector('[data-rv2-upsell-hint]') : null);
    }
    var containers = scope.querySelectorAll('.cart-drawer-upsells-container');
    for (var j = 0; j < containers.length; j++) {
      var c = containers[j];
      var title = (c.querySelector && c.querySelector('.upsell__outside-title')) || (c.parentNode && c.parentNode.querySelector ? c.parentNode.querySelector('.upsell__outside-title') : null);
      wireOne(c, title);
    }
  }

  function walletPriority(name, appleDevice) {
    var appleOrder = ['shop_pay', 'apple_pay', 'paypal', 'google_pay'];
    var defaultOrder = ['shop_pay', 'google_pay', 'paypal', 'apple_pay'];
    var order = appleDevice ? appleOrder : defaultOrder;
    var index = order.indexOf(String(name || '').toLowerCase());
    return index === -1 ? order.length + 1 : index;
  }

  /**
   * Shopify renders the cart wallets from the public `wallet-configs` attribute
   * on <shopify-accelerated-checkout-cart>. Keep the three most useful wallets
   * so the component has enough room to remain in its horizontal cart layout,
   * including inside the narrow mobile drawer.
   */
  function limitExpressWallets(scope) {
    var wallets = scope.querySelectorAll('shopify-accelerated-checkout-cart[wallet-configs]:not([data-rv2-wallet-limit])');
    var appleDevice = false;
    try {
      appleDevice = !!window.ApplePaySession || /iPhone|iPad|iPod|Macintosh/i.test(navigator.userAgent || '');
    } catch (e) {}

    for (var i = 0; i < wallets.length; i++) {
      var el = wallets[i];
      var configs;
      try { configs = JSON.parse(attr(el, 'wallet-configs')); } catch (e) { configs = null; }
      if (!Array.isArray(configs) || !configs.length) {
        el.setAttribute('data-rv2-wallet-limit', 'unavailable');
        continue;
      }

      if (configs.length <= 3) {
        el.setAttribute('data-rv2-wallet-limit', String(configs.length));
        continue;
      }

      configs = configs.map(function (config, originalIndex) {
        return { config: config, originalIndex: originalIndex };
      }).sort(function (a, b) {
        var pa = walletPriority(a.config && a.config.name, appleDevice);
        var pb = walletPriority(b.config && b.config.name, appleDevice);
        return pa === pb ? a.originalIndex - b.originalIndex : pa - pb;
      }).slice(0, 3).map(function (entry) { return entry.config; });

      var checkoutDefined = false;
      try {
        checkoutDefined = !!(window.customElements && window.customElements.get('shopify-accelerated-checkout-cart'));
      } catch (e) {}

      var target = el;
      if (checkoutDefined) {
        target = el.cloneNode(true);
      }
      target.setAttribute('wallet-configs', JSON.stringify(configs));
      target.setAttribute('data-rv2-wallet-limit', String(configs.length));

      var skeletonCells = target.querySelectorAll('[data-shopify-buttoncontainer] > *, [role="list"] > *');
      for (var c = skeletonCells.length - 1; c >= configs.length; c--) {
        if (skeletonCells[c] && skeletonCells[c].parentNode) skeletonCells[c].parentNode.removeChild(skeletonCells[c]);
      }

      if (checkoutDefined && el.parentNode) el.parentNode.replaceChild(target, el);
    }
  }

  function requestKey(node, code) {
    return 'rv2_discount_' + encodeURIComponent(attr(node, 'data-cart-token') || 'cart') + '_' + encodeURIComponent(code) + '_' + (attr(node, 'data-qualifying-qty') || '0');
  }
  function applyEligibleDiscounts(scope) {
    var nodes = scope.querySelectorAll('[data-rv2-offer][data-auto-apply="true"]');
    for (var i = 0; i < nodes.length; i++) {
      (function (node) {
        var eligible = attr(node, 'data-discount-eligible') === 'true';
        var applied = attr(node, 'data-discount-applied') === 'true';
        var code = attr(node, 'data-discount-code').trim();
        if (!eligible || applied || !code) return;

        var key = requestKey(node, code);
        if (applyingDiscounts[key] || ssGet(key)) return;
        applyingDiscounts[key] = true;
        ssSet(key, Date.now());
        node.setAttribute('data-discount-requested', 'true');

        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
        fetch(root + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            discount: code,
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        }).then(function (response) {
          if (!response.ok) throw new Error('Discount update failed: ' + response.status);
          return response.json();
        }).then(function (data) {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
            drawer.renderContents(data, true);
          }
          try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: data, source: 'rolvea-discount' } })); } catch (e) {}
        }).catch(function () {
          ssRemove(key);
          node.removeAttribute('data-discount-requested');
        }).finally(function () {
          delete applyingDiscounts[key];
        });
      })(nodes[i]);
    }
  }

  function init() {
    var scope = document.getElementById(DRAWER_ID) || document;
    limitExpressWallets(scope);
    fillScarcity(scope);
    fillDelivery(scope);
    wireCarousel(scope);
    applyEligibleDiscounts(scope);
  }

  var OBS_OPTS = { childList: true, subtree: true };
  var observer = null;
  var debounceTimer = null;
  function scheduleInit() { if (debounceTimer) clearTimeout(debounceTimer); debounceTimer = setTimeout(runInit, 120); }
  function runInit() {
    var drawer = document.getElementById(DRAWER_ID);
    if (observer) observer.disconnect();
    try { init(); } catch (e) {}
    if (drawer) { if (!observer) observer = new MutationObserver(scheduleInit); observer.observe(drawer, OBS_OPTS); }
  }

  if (document.readyState !== 'loading') runInit(); else document.addEventListener('DOMContentLoaded', runInit);
  document.addEventListener('shopify:section:load', runInit);
  if (window.PUB_SUB_EVENTS && window.subscribe && window.PUB_SUB_EVENTS.cartUpdate) {
    try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, runInit); } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var cta = e.target && e.target.closest ? e.target.closest('[data-rv2-scroll-upsell]') : null;
    if (cta) {
      e.preventDefault();
      var drawer = document.getElementById(DRAWER_ID);
      var carousel = drawer && (drawer.querySelector('.rv2-upsell') || drawer.querySelector('.cart-drawer-upsells-container'));
      if (carousel && carousel.scrollIntoView) carousel.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' });
      return;
    }

    var card = e.target && e.target.closest ? e.target.closest('.rv2-upsell__card[data-product-url]') : null;
    if (!card) return;
    if (e.target.closest('a, button, input, select, textarea, form, product-form')) return;
    var url = attr(card, 'data-product-url');
    if (url) window.location.href = url;
  });

  window.RolveaCartV2 = { init: runInit };
})();
